import "./styles.modules.scss";

import React, { useState, Fragment } from "react";
import { Button, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { BsTrash as TrashIco } from "react-icons/bs";
import { MdInfo } from "react-icons/md";

const AlternativeCard = ({ item, index, trashEvent }) => {
  const [cont, setCont] = useState(item?.title?.length || 0);
  const [valueLocal, setValueLocal] = useState(
    typeof item.value === "number" ? item.value : 0
  );

  const handleChangeValue = (e) => {
    const raw = parseInt(e.currentTarget.value, 10);
    //const clamped = Number.isNaN(raw) ? 0 : Math.max(0, Math.min(5, raw));
    setValueLocal(raw);
    item.value = raw;
  };

  return (
    <div className="altIt">
      <div
        className="altItSelec altItSelecItemCustom"
        style={{
          display: "grid",
          gridTemplateColumns: "70px 1fr",
          columnGap: 12,
          alignItems: "start",
        }}
      >
        <div style={{ width: 70 }}>
          <div
            className="contador"
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              color: "#6c757d",
              textAlign: "left",
              marginTop: 4,
            }}
          >
            <OverlayTrigger
              trigger={["hover", "focus", "click"]}
              placement="top"
              rootClose
              overlay={
                <Tooltip id={`tt-valor-${index}`}>
                  Atribua um valor numérico para cada opção; ele representa o
                  peso da resposta no cálculo da média/pontuação. Ex.: 1 =
                  Péssimo, 5 = Excelente.
                </Tooltip>
              }
            >
              <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                <MdInfo size={16} color="#000" />
                <span>Valor *</span>
              </span>
            </OverlayTrigger>
          </div>

          <Form.Control
            type="number"
            //min={0}
            // max={5}
            step={1}
            value={valueLocal}
            onChange={handleChangeValue}
            style={{ textAlign: "center", color: valueLocal === 0 ? "#B0B0B0" : "#000000" }}
          />

          <div
            className="contador"
            style={{ visibility: "hidden", marginTop: 4, textAlign: "right" }}
            aria-hidden="true"
          >
            <span>00</span>/45
          </div>
        </div>

        <div style={{ width: "100%" }}>
          <div className="contador" style={{ textAlign: "left", marginTop: 4, color: "#6c757d" }}>
            <span>Alternativa</span>
          </div>
          <Form.Control
            as="textarea"
            rows={1}
            defaultValue={item.title}
            maxLength={45}
            onChange={(e) => {
              item.title = e.currentTarget.value;
              setCont(e.currentTarget.value.length);
            }}
            placeholder={`Digite a alternativa ${index + 1}`}
          />
          <div className="contador" style={{ textAlign: "right", marginTop: 4 }}>
            <span>{cont}</span>/45
          </div>
        </div>
      </div>

      <div className="altRemove">
        <p>Remover</p>
        <button onClick={() => trashEvent(index)}>
          <TrashIco />
        </button>
      </div>
    </div>
  );
};

const LikertScale = ({ questionScales, setQuestionScales }) => {
  const addAlt = () => {
    setQuestionScales((item) => [...item, { title: "", value: 0 }]);
  };

  const trashEvent = (index) => {
    const newquestionScale = [...questionScales];
    newquestionScale.splice(index, 1);
    setQuestionScales(newquestionScale);
  };

  return (
    <div className="form-group form-group-block-02">
      <div className="card">
        <div className="card-header template-card-header">Escala linear</div>
        <div className="card-body template-card-body">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 altContainer">
              <div className="altList">
                {questionScales.length > 0 ? (
                  questionScales.map((item, index) => (
                    <Fragment key={index}>
                      <AlternativeCard
                        item={item}
                        index={index}
                        trashEvent={trashEvent}
                      />
                    </Fragment>
                  ))
                ) : (
                  <div className="noAlternative">Sem nenhuma alternativa.</div>
                )}
              </div>

              <Button variant="warning" className="btnAdd" onClick={addAlt}>
                Adicionar nova alternativa
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LikertScale;
